import React from 'react';
import PropTypes from 'prop-types';
import { efesGrayish } from '../../../theme';

const Facebook = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28.338 28.337">
    <path
      id="facebook-rect"
      d="M5.174,0A5.163,5.163,0,0,0,0,5.174V23.163a5.163,5.163,0,0,0,5.174,5.174h9.75V17.259H11.995V13.271h2.929V9.863c0-2.677,1.731-5.135,5.718-5.135a24.16,24.16,0,0,1,2.808.155l-.094,3.725S22.138,8.6,20.81,8.6c-1.438,0-1.668.663-1.668,1.762v2.912h4.329l-.189,3.989h-4.14V28.337h4.022a5.163,5.163,0,0,0,5.174-5.174V5.174A5.163,5.163,0,0,0,23.164,0Z"
      fill={color}
    />
  </svg>
);

Facebook.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
};

Facebook.defaultProps = {
  width: 28.338,
  height: 28.337,
  color: efesGrayish,
};

export default Facebook;
